import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

// Utiliza Framer Motion para animar el scroll
export const scrollToSection = (hash) => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  const id = hash.replace("#", "");
  const el = document.getElementById(id);
  if (el) {
    const yOffset = -72;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export function useSmoothNavigate() {
  const location = useLocation();
  const navigate = useNavigate();

  // Navegación suave compatible con rutas y hash
  const smoothNavigate = useCallback(
    (e, href) => {
      if (!href.startsWith("#") && !href.startsWith("/#")) return;
      e.preventDefault();
      const hash = href.startsWith("/#") ? href.replace("/", "") : href;
      if (location.pathname !== "/") {
        navigate(`/${hash}`);
      } else {
        const sectionId = hash.replace("#", "");
        window.history.pushState(null, "", `/#${sectionId}`);
        scrollToSection(hash);
      }
    },
    [location, navigate]
  );

  return smoothNavigate;
}
